export default [
  {
    label: 'キャンプ場の方からのご要望',
    value: 9,
  },
  {
    label: 'キャンプ場の新規登録依頼',
    value: 10,
  },
  {
    label: '取材・掲載について',
    value: 11,
  },
  {
    label: 'アンケート配信について',
    value: 12,
  },
  {
    label: '協賛・コラボについて',
    value: 13,
  },
  {
    label: 'iihi提携キャンプ場・ロトシーズ協賛品について',
    value: 15,
  },
  {
    label: 'その他',
    value: 14,
  },
];
